import { render, staticRenderFns } from "./FetchDataLoadingMessage.vue?vue&type=template&id=696d963f"
import script from "./FetchDataLoadingMessage.vue?vue&type=script&lang=js"
export * from "./FetchDataLoadingMessage.vue?vue&type=script&lang=js"
import style0 from "./FetchDataLoadingMessage.vue?vue&type=style&index=0&id=696d963f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports